import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import MainImageForm from '../../common/image/MainImageForm';

function CircumstanceManager({ isOpen, onClose, circumstance, loading, onUpdate, onCreate }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (circumstance) {
      setTitle(circumstance.title);
      setImages(circumstance.images);
      setDescription(circumstance.description);
    } else {
      setTitle('');
      setImages([]);
      setDescription('');
    }
  }, [circumstance, isOpen]);

  const handleValidate = () => {
    const circumstancePayload = {
      title,
      images: images.map((image) => image.id),
      description
    };
    circumstance ? onUpdate(circumstancePayload) : onCreate(circumstancePayload);
  };

  const formIsValid = () => {
    return images.length > 0;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${circumstance ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${circumstance ? 'Modifier' : 'Ajouter'} une circonstance`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput label={`Titre de la circonstance`}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de l'article"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput label={'Description'}>
            <InputText
              id="description"
              value={description}
              maxLength={300}
              placeholder="Veuillez saisir la description de la circonstance"
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormInput>
          {images.length > 0 && (
            <div className="flex flex-wrap gap-5">
              {images.map((image, index) => (
                <MainImageForm
                  mainImage={image}
                  setMainImage={(img) => setImages({ ...images, [index]: img })}
                  label={`Image ${index + 1}`}
                />
              ))}
            </div>
          )}
          <MainImageForm
            mainImage={undefined}
            setMainImage={(img) => setImages([...images, img])}
            label="Ajouter une nouvelle image"
            required={images.length === 0}
          />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default CircumstanceManager;
